// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__RQQHj","chip":"style_chip__3-Ro1"};